'use client'

import React, { createContext, useContext, useState } from 'react'

/* eslint-disable react-refresh/only-export-components -- context module */

interface MiniCartContextType {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
}

const MiniCartContext = createContext<MiniCartContextType | undefined>(undefined)

export function MiniCartProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false)

    return <MiniCartContext.Provider value={{ isOpen, setIsOpen }}>{children}</MiniCartContext.Provider>
}

export function useMiniCart() {
    const context = useContext(MiniCartContext)
    if (context === undefined) {
        throw new Error('useMiniCart must be used within a MiniCartProvider')
    }
    return context
}
